import React from 'react';
import uniqid from 'uniqid';

export const getSocialAndTagsWrapper = (tags, social) => (
  <div className="polaris__content-bottom" key={uniqid('SocialTagWrapper-')}>
    {tags}
    {social}
  </div>
);
